import { memo } from "react";
/**
 * @typedef {Object} TopImageType
 * @property {string} imageSrc - source of image
 * @property {string} text - text on image
 */

/**
 * TopImage component renders a top bar  image and title.
 *
 * @param {TopImageType} props - Component props
 * @returns {JSX.Element}
 */
const TopImage = ({ imageSrc, text }) => {
  return (
    <div className="classroom-container">
      <img src={imageSrc} className="img" alt="Classroom" />
      <h2 className="text">{text}</h2>
    </div>
  );
};

export default memo(TopImage);
